
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/clubs",
      function () {
        return require("private-next-pages/clubs.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/clubs"])
      });
    }
  